import { render, staticRenderFns } from "./project.vue?vue&type=template&id=cdcecc3e&scoped=true"
import script from "./project.vue?vue&type=script&lang=ts"
export * from "./project.vue?vue&type=script&lang=ts"
import style0 from "./project.vue?vue&type=style&index=0&id=cdcecc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcecc3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnReadmore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-readmore.vue').default})
